import React, { Component } from "react";
import styled from "styled-components";
import moment from "moment";
import { observable } from "mobx";
import { observer } from "mobx-react";
import Panel from "./common/Panel";
import Toggle from "./common/Toggle";
import InputRowRaw from "module-common/InputRow";
import Button from "module-common/Button";
import { graphql, compose } from "react-apollo";
import {
  queryGetCompany,
  queryGetCompanyConfiguration,
  queryGetTemplateCsat,
  mutationAddCompanyConfiguration,
  mutationUpdateCompany,
  mutationAddTemplateCsat
} from "Apollo";
import { CommonStore, ShowNotice } from "Store";

import { Select } from "antd";
import PropTypes from "prop-types";

const Option = Select.Option;
export default compose(
  graphql(queryGetCompany, { name: "company" }),
  graphql(queryGetCompanyConfiguration, { name: "config" }),
  graphql(queryGetTemplateCsat, { name: "csat" }),
  graphql(mutationAddCompanyConfiguration, { name: "mutateConfig" }),
  graphql(mutationUpdateCompany, { name: "mutateCompany" }),
  graphql(mutationAddTemplateCsat, { name: "mutateCsat" })
)(
  observer(
    class ConfigPanel extends Component {
      states = observable({
        companyName: "",
        description: "",
        password: "",
        confirmPassword: "",
        workingStart: moment().set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        }),
        workingEnd: moment().set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        }),
        slaResponseRate: 0,
        slaResponseTime: 0,
        slaHandlingTime: 0,
        nickActive: false,
        replyLabelActive: false,
        autoAssignActive: false,
        channelSignatureActive: false,
        csatActive: false,
        csatTemplate: "",
        csatSignature:
          "Bales angka: 5=Sgt puas, 4=Puas, 3=Biasa, 2=Tdk puas, 1=Sgt tidak puas.",
        loadingButtonSaveCompany: false,
        loadingButtonSaveConfig: false,
        loadingButtonSaveCsat: false,
        selectResponseTime: "second",
        selectHandlingTime: "second"
      });

      componentWillReceiveProps(nextProps) {
        const { company, config, csat } = nextProps;
        const companyValue = company.getCompany;
        const configValue = config.getCompanyConfiguration;
        const csatValue = csat.getTemplateCsat;
        if (csatValue) {
          this.states.csatTemplate = csatValue.content;
        }

        if (companyValue) {
          this.states.companyName = companyValue.displayName;
          this.states.description = companyValue.description;
        }

        if (configValue) {
          this.states.workingStart = moment.unix(configValue.workingStart);
          this.states.workingEnd = moment.unix(configValue.workingEnd);
          this.states.slaResponseRate = configValue.responseRateSLA;
          this.states.slaResponseTime = configValue.responseTimeSLA;
          this.states.slaHandlingTime = configValue.handlingTimeSLA;
          this.states.nickActive = configValue.nickActive;
          this.states.replyLabelActive = configValue.replyLabelActive;
          this.states.autoAssignActive = configValue.autoAssignActive;
          this.states.channelSignatureActive = configValue.iconCompanyActive;
          this.states.csatActive = configValue.csatActive;
        }
      }
      static propTypes = {
        id: PropTypes.number,
        label: PropTypes.string,
        show: PropTypes.bool,
        refetch: PropTypes.func
      };

      render() {
        return (
          <Panel title="CONFIGURATION">
            <Title>Basic info</Title>
            <InputRow
              label="Company Name"
              inputWidth={280}
              value={this.states.companyName}
              onChange={text => {
                this.states.companyName = text;
              }}
            />
            <InputRow
              type="textarea"
              label="Description"
              inputWidth={280}
              value={this.states.description}
              onChange={text => {
                this.states.description = text;
              }}
            />
            {
              // <InputRow
              //   type="password"
              //   label="Change Password"
              //   inputWidth={140}
              //   isPassword
              //   value={this.states.password}
              //   onChange={text => {
              //     this.states.password = text;
              //   }}
              // />
              // <InputRow
              //   type="password"
              //   label="Confirm New Password"
              //   inputWidth={140}
              //   isPassword
              //   value={this.states.confirmPassword}
              //   onChange={text => {
              //     this.states.confirmPassword = text;
              //   }}
              // />
            }
            <Button
              rounded
              width={100}
              onClick={this.onSaveCompany}
              loading={this.states.loadingButtonSaveCompany}
              disabled={this.states.loadingButtonSaveCompany}
            >
              Save
            </Button>

            <Title>Advance Setting</Title>
            <InputRow
              type="timepicker"
              label="Working hour starts"
              inputWidth={140}
              value={this.states.workingStart}
              onChange={value => {
                this.states.workingStart = value;
              }}
            />
            <InputRow
              type="timepicker"
              label="Working hour ends"
              inputWidth={140}
              value={this.states.workingEnd}
              onChange={value => {
                this.states.workingEnd = value;
              }}
            />
            <InputRow
              label="SLA for Response Rate"
              inputWidth={140}
              afterLabel="%"
              value={this.states.slaResponseRate.toString()}
              onChange={text => {
                let percent = parseInt(text, 10);
                if (isNaN(percent) || percent < 0) {
                  percent = 0;
                } else if (percent > 100) {
                  percent = 100;
                }
                this.states.slaResponseRate = percent;
              }}
            />

            <ContainerSLA>
              <InputRow
                label="SLA for Response Time"
                inputWidth={140}
                value={this.states.slaResponseTime.toString()}
                onChange={text => {
                  let value = parseInt(text, 10);
                  if (isNaN(value) || value < 0) {
                    value = 0;
                  }
                  this.states.slaResponseTime = value;
                }}
              />

              <Select
                defaultValue="0"
                style={{ width: 120 }}
                onChange={item => this.changeSelectResponseTime(item)}
              >
                <Option value="0">Second</Option>
                <Option value="1">Minutes</Option>
                <Option value="2">Hour</Option>
              </Select>
            </ContainerSLA>

            <ContainerSLA>
              <InputRow
                label="SLA for Handling TIme"
                inputWidth={140}
                value={this.states.slaHandlingTime.toString()}
                onChange={text => {
                  let value = parseInt(text, 10);
                  if (isNaN(value) || value < 0) {
                    value = 0;
                  }

                  this.states.slaHandlingTime = value;
                }}
              />

              <Select
                defaultValue="0"
                style={{ width: 120 }}
                onChange={item => this.changeSelectHandlingTime(item)}
              >
                <Option value="0">Second</Option>
                <Option value="1">Minutes</Option>
                <Option value="2">Hour</Option>
              </Select>
            </ContainerSLA>
            <ContainerSLA>
              <Label>Agent Signature</Label>
              <Toggle
                toggled={this.states.nickActive}
                onToggle={toggled => (this.states.nickActive = toggled)}
              />
            </ContainerSLA>
            <ContainerSLA>
              <Label>Account Signature</Label>
              <Toggle
                toggled={this.states.channelSignatureActive}
                onToggle={toggled =>
                  (this.states.channelSignatureActive = toggled)
                }
              />
            </ContainerSLA>
            <ContainerSLA>
              <Label>Reply Label</Label>
              <Toggle
                toggled={this.states.replyLabelActive}
                onToggle={toggled => (this.states.replyLabelActive = toggled)}
              />
            </ContainerSLA>
            <ContainerSLA>
              <Label>Auto Assign</Label>
              <Toggle
                toggled={this.states.autoAssignActive}
                onToggle={toggled => (this.states.autoAssignActive = toggled)}
              />
            </ContainerSLA>
            <ContainerSLA>
              <Label>CSAT</Label>
              <Toggle
                toggled={this.states.csatActive}
                onToggle={toggled => (this.states.csatActive = toggled)}
              />
            </ContainerSLA>
            <InputRow
              type="textarea"
              label="CSAT Template"
              inputWidth={280}
              value={this.states.csatTemplate}
              onChange={text => {
                this.states.csatTemplate = text;
              }}
              disabled={!this.states.csatActive}
            />
            <InputRow
              type="textarea"
              label="CSAT Signature"
              inputWidth={280}
              value={this.states.csatSignature}
              disabled={true}
            />
            <Button
              rounded
              width={100}
              onClick={this.onSaveConfig}
              loading={this.states.loadingButtonSaveConfig}
              disabled={this.states.loadingButtonSaveConfig}
            >
              Save
            </Button>
          </Panel>
        );
      }

      changeSelectResponseTime = item => {
        if (item === "0") {
          this.states.selectResponseTime = "second";
        } else if (item === "1") {
          this.states.selectResponseTime = "minute";
        } else if (item === "2") {
          this.states.selectResponseTime = "hour";
        }
      };

      changeSelectHandlingTime = item => {
        if (item === "0") {
          this.states.selectHandlingTime = "second";
        } else if (item === "1") {
          this.states.selectHandlingTime = "minute";
        } else if (item === "2") {
          this.states.selectHandlingTime = "hour";
        }
      };

      onSaveCompany = async () => {
        const { companyName, description } = this.states;
        this.states.loadingButtonSaveCompany = true;
        try {
          await this.props.mutateCompany({
            variables: {
              companyDisplayName: companyName,
              companyDescription: description
            },
            refetchQueries: ["getCompany"]
          });
          ShowNotice("config-update-success");
        } catch (error) {
          ShowNotice("config-update-error");
        }
        this.states.loadingButtonSaveCompany = false;
      };

      onSaveConfig = async () => {
        if (this.states.selectResponseTime) {
          if (this.states.selectResponseTime === "second") {
            this.states.slaResponseTime = this.states.slaResponseTime;
          } else if (this.states.selectResponseTime === "minute") {
            this.states.slaResponseTime = this.states.slaResponseTime * 60;
          } else if (this.states.selectResponseTime === "hour") {
            this.states.slaResponseTime = this.states.slaResponseTime * 3600;
          }
        }

        if (this.states.selectHandlingTime) {
          if (this.states.selectHandlingTime === "second") {
            this.states.slaHandlingTime = this.states.slaHandlingTime;
          } else if (this.states.selectHandlingTime === "minute") {
            this.states.slaHandlingTime = this.states.slaHandlingTime * 60;
          } else if (this.states.selectHandlingTime === "hour") {
            this.states.slaHandlingTime = this.states.slaHandlingTime * 3600;
          }
        }

        const {
          workingStart,
          workingEnd,
          slaResponseRate,
          slaResponseTime,
          slaHandlingTime,
          nickActive,
          replyLabelActive,
          autoAssignActive,
          channelSignatureActive,
          csatActive,
          csatTemplate
        } = this.states;

        this.states.loadingButtonSaveConfig = true;
        try {
          await this.props.mutateConfig({
            variables: {
              workingStart: workingStart.unix(),
              workingEnd: workingEnd.unix(),
              responseRateSla: slaResponseRate,
              responseTimeSla: slaResponseTime,
              handlingTimeSla: slaHandlingTime,
              nickActive: nickActive,
              replyLabelActive: replyLabelActive,
              autoAssignActive: autoAssignActive,
              iconCompanyActive: channelSignatureActive,
              csatActive: csatActive
            },
            refetchQueries: ["getCompanyConfiguration"]
          });
          await this.props.mutateCsat({
            variables: {
              content: csatTemplate
            },
            refetchQueries: ["getTemplateCsat"]
          });
          ShowNotice("config-update-success");
        } catch (error) {
          ShowNotice("config-update-error");
        }
        this.states.loadingButtonSaveConfig = false;
        this.states.selectHandlingTime = "second";
        this.states.selectResponseTime = "second";
      };
    }
  )
);

const Title = styled.div`
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
`;
const InputRow = styled(InputRowRaw)`
  margin-bottom: 10px;
  margin-right: 0;
`;
const ContainerSLA = styled.section`
  display: flex;
  flex: none;
  justify-content: flex-start;
  height: 40px;
`;
const Label = styled.div`
  font-size: 0.9rem;
  width: 150px;
  margin-bottom: 10px;
  cursor: default;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/ConfigPanelWithQueryMutation.js